import { groupBy } from 'lodash-es'
import * as React from 'react'
import { Avatar } from 'src/design-system'
import { CollapsibleTable } from 'src/design-system/components/organisms/CollapsibleTable'
import { Team } from '../types'
import { avatarFallback } from '../utils'
import { useWfiContext } from '../WfiContext'

const HEADINGS = {
  role: 'Role',
  headcount: 'Headcount',
  users: 'Hidden/upcoming talents',
}

type ProposalGrowProps = {
  id: number
}

export const ProposalGrow: React.VFC<ProposalGrowProps> = ({ id }) => {
  const { analyses, orgSnapshot } = useWfiContext()

  const analysis = analyses.find((a) => a.id === id)

  if (analysis == null) return null

  const teamsById = (() => {
    const map = new Map<number, Team>()
    for (const team of analysis.teams) {
      map.set(team.id, team)
    }
    return map
  })()

  const groupedRows = Object.entries(
    groupBy(
      analysis.changes.positions?.added ?? [],
      (position) => position.team_id
    )
  ).map(([teamId, positions]) => {
    return {
      name: teamsById.get(Number(teamId))?.name ?? '',
      display: teamsById.get(Number(teamId))?.name ?? '',
      rows: positions.map((p) => ({
        role: p.name,
        headcount: p.opening_count || 1,
        users:
          p.user_suggestions.length === 0
            ? 'No suggested users'
            : p.user_suggestions.map((u) => {
                const user = orgSnapshot?.usersById.get(u.id)
                if (user == null) return null
                return (
                  <>
                    <Avatar
                      alt={user.name}
                      fallbackText={avatarFallback(user.name)}
                      size="xs"
                      src={user.avatar_url}
                    />
                    <p>{user?.name ?? 'Invalid user id'}</p>
                  </>
                )
              }),
      })),
    }
  })

  return (
    <div>
      <CollapsibleTable headings={HEADINGS} groupedRows={groupedRows} />
    </div>
  )
}
